<template>
  <div :class="{'sidebar_bottom' : isHorizontal }">
    <ul class="as__menu">
      <li>
        <router-link :to="{ name: 'home' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('home')}">
          <i class="as__menu__link__icon">
            <HomeIco/>
          </i>
          <span class="as__menu__link__title">Рабочий стол</span>
        </router-link>
      </li>

      <li v-if="$store.state.me.role !== 'partner'">
        <router-link :to="{ name: 'tasks' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('tasks')}">
          <i class="as__menu__link__icon">
            <TaskIco/>
          </i>
          <span class="as__menu__link__title">Задачи</span>
          <span
            class="as__menu__link__badge as__menu__link__badge--orange"
            :class="{ 'as__menu__link__badge--less-rounded' : $store.state._allDoTasksMeta.count > 99 }"
            v-if="$store.state._allDoTasksMeta.count"
            v-tooltip="'1С'"
          >
          {{ $store.state._allDoTasksMeta.count > 99 ? '99+' : $store.state._allDoTasksMeta.count }}
        </span>
          <span class="as__menu__link__badge" v-else-if="$store.state.expiredTasks">{{ $store.state.expiredTasks }}</span>
        </router-link>
        <ul class="as__submenu">
          <li>
            <router-link :to="{ name: 'tasks', hash: '#table' }" class="as__submenu__link" :class="{ active: isSubRouterLinkActive('tasks#table')}">
              CRM{{ $store.state.expiredTasks ? ` (${$store.state.expiredTasks})` : '' }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'tasks', hash: '#tableDo' }" class="as__submenu__link" :class="{ active: isSubRouterLinkActive('tasks#tableDo')}">
              1C{{ $store.state._allDoTasksMeta.count ? ` (${$store.state._allDoTasksMeta.count})` : '' }}
            </router-link>
          </li>
        </ul>
      </li>

      <!-- Сделки -->
      <li
        v-if="$store.state.me.role !== 'partner'"
        @mouseover="!isHorizontal && !isMobile ? closeAllExcept('submenu_trades', true) : null"
        @mouseleave="!isHorizontal && !isMobile ? closeAllExcept('submenu_trades', false) : null"
      >
        <label
          :for="!isHorizontal ? 'submenu_trades' : ''"
          @click="!isMobile || isHorizontal ? $router.push({ name: 'trades' }) : null"
          :class="{
            active: isSubRouterLinkActive(['trades', 'memos', 'addmemo'])
          }"
          class="as__menu__link"
        >
          <i class="as__menu__link__icon">
            <DocPlus/>
          </i>
          <span class="as__menu__link__title">Сделки</span>

          <span
            class="as__menu__link__badge"
            v-if="$store.state.unprocessedLeads && ($store.state.me.roles.includes('КЦ (Лизинг)') || $store.state.me.role === 'admin')"
          >
            {{ $store.state.unprocessedLeads }}
          </span>

        </label>

        <input
          class="submenu-checkbox"
          type="checkbox"
          id="submenu_trades"
          ref="submenu_trades"
          @change="closeAllExcept('submenu_trades', $refs.submenu_trades.checked)"
        >

        <ul
          v-if="!isHorizontal"
          class="as__submenu as__submenu--trades"
        >
          <li @click="$router.push({ name: 'trades' })">
            <label for="submenu_trades">
              <span
                class="as__submenu__link"
                :class="{ active: isSubRouterLinkActive('trades')}"
              >
                Сделки
              </span>
            </label>
          </li>

          <li @click="$router.push({ name: 'memos' })">
            <label for="submenu_trades">
              <span
                class="as__submenu__link"
                :class="{ active: isSubRouterLinkActive('memos')}"
              >
                Служебки
              </span>
            </label>
          </li>
        </ul>
      </li>

      <li v-if="$store.state.me.role !== 'partner'">
        <router-link :to="{ name: 'calculators' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('calculators')}">
          <i class="as__menu__link__icon">
            <CalcIco/>
          </i>
          <span class="as__menu__link__title">Калькуляторы</span>
        </router-link>
      </li>

      <!-- Справочник -->
      <li
        v-if="$store.state.me.role !== 'partner'"
        @mouseover="!isHorizontal && !isMobile ? closeAllExcept('submenu_digest', true) : null"
        @mouseleave="!isHorizontal && !isMobile ? closeAllExcept('submenu_digest', false) : null"
      >
        <label
          :for="!isHorizontal ? 'submenu_digest' : ''"
          :class="{
            active: isSubRouterLinkActive([ 'contacts', 'companies', 'directory'])
          }"
          @click="!isMobile || isHorizontal ? $router.push({ name: 'companies' }) : null"
          class="as__menu__link"
        >
          <i class="as__menu__link__icon">
            <ContactIco/>
          </i>
          <span class="as__menu__link__title">Справочник</span>
        </label>

        <input
          class="submenu-checkbox"
          type="checkbox"
          id="submenu_digest"
          ref="submenu_digest"
          @change="closeAllExcept('submenu_digest', $refs.submenu_digest.checked)"
        >

        <ul
          v-if="!isHorizontal"
          class="as__submenu as__submenu--digest"
        >
          <li @click.capture="$router.push({ name: 'companies' })">
            <label for="submenu_digest">
              <span
                class="as__submenu__link"
                :class="{ active: isSubRouterLinkActive('companies')}"
              >
                Компании
              </span>
            </label>
          </li>
          <li @click.capture="$router.push({ name: 'directory' })">
            <label for="submenu_digest">
              <span
                class="as__submenu__link"
                :class="{ active: isSubRouterLinkActive('directory')}"
              >
                Сотрудники
              </span>
            </label>
          </li>
        </ul>
      </li>

      <li>
        <router-link :to="{ name: 'contracts' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('contracts')}">
          <i class="as__menu__link__icon">
            <DocumentsIco/>
          </i>
          <span class="as__menu__link__title">Договоры лизинга</span>
        </router-link>
      </li>

      <li v-if="$store.state.me.role === 'partner'">
        <router-link :to="{ name: 'apply' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('apply')}">
          <i class="as__menu__link__icon">
            <ApplyIco/>
          </i>
          <span class="as__menu__link__title">Подать заявку</span>
        </router-link>
      </li>

      <mq-layout :mq="['lg', 'xlg', 'xl']">
        <li v-if="$store.state.me.role !== 'partner'">
          <router-link :to="{ name: 'property-valuation' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('property-valuation')}">
            <i class="as__menu__link__icon">
              <CarIcon/>
            </i>
            <span class="as__menu__link__title">Оценка авто</span>
          </router-link>
        </li>

        <li v-if="$store.state.me.role !== 'partner'">
          <router-link :to="{ name: 'seized-properties' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('seized-properties')}">
            <i class="as__menu__link__icon">
              <TruckIcon/>
            </i>
            <span class="as__menu__link__title">Изъятое имущество</span>
          </router-link>
        </li>

        <li v-if="[
        'Администраторы',
        'Генеральный директор',
        'Руководитель подразделения (Лизинг)'
        ]
          .filter(x => $store.state.me.roles.includes(x))
          .length
      ">
          <router-link :to="{ name: 'edo' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('edo')}">
            <i class="as__menu__link__icon">
              <DiadocIcon/>
            </i>
            <span class="as__menu__link__title">ЭДО</span>
            <span class="as__menu__link__badge" v-if="$store.state.diadocDocuments">{{ $store.state.diadocDocuments }}</span>
          </router-link>
        </li>

        <!-- Аналитка -->
        <li
          v-if="$store.state.me.role !== 'partner'"
          @mouseover="!isHorizontal && !isMobile ? closeAllExcept('submenu_analytics', true) : null"
          @mouseleave="!isHorizontal && !isMobile ? closeAllExcept('submenu_analytics', false) : null"
        >
          <label
            :for="!isHorizontal ? 'submenu_analytics' : ''"
            :class="{ active: isSubRouterLinkActive('analytics')}"
            @click="!isMobile || isHorizontal ? $router.push({ name: 'analytics' }) : null"
            class="as__menu__link"
          >
            <i class="as__menu__link__icon">
              <DocumentationIco/>
            </i>
            <span class="as__menu__link__title">Аналитика</span>
          </label>

          <input
            class="submenu-checkbox"
            type="checkbox"
            id="submenu_analytics"
            ref="submenu_analytics"
            @change="closeAllExcept('submenu_analytics', $refs.submenu_analytics.checked)"
          >

          <ul
            v-if="['headmanager', 'callcenter', 'admin'].includes($store.state.me.role) && !isHorizontal"
            class="as__submenu as__submenu--analytics"
          >
            <li @click="$router.push({ name: 'analytics' })">
              <label for="submenu_analytics">
                <span
                  class="as__submenu__link"
                  :class="{ active: isSubRouterLinkActive('analytics')}"
                >
                  Аналитика
                </span>
              </label>
            </li>

            <li @click="$router.push({ name: 'diagrams' })">
              <label for="submenu_analytics">
                <span
                  class="as__submenu__link"
                  :class="{ active: isSubRouterLinkActive('diagrams')}"
                >
                  Диаграммы
                </span>
              </label>
            </li>
          </ul>
        </li>

        <li v-if="$store.state.me.role !== 'partner'">
          <router-link :to="{ name: 'courses' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('courses')}">
            <i class="as__menu__link__icon">
              <CoursesIcon/>
            </i>
            <span class="as__menu__link__title">Курсы</span>
            <span class="as__menu__link__badge"
                  v-if="$store.state.me.courses && $store.state.me.courses.filter(elem => !elem.completion_date && !(/\/course\//.test(elem.link) && elem.viewed)).length > 0">{{
                $store.state.me.courses.filter(elem => !elem.completion_date && !(/\/course\//.test(elem.link) && elem.viewed)).length
              }}</span>
          </router-link>
        </li>

        <li v-if="this.$store.state.allFaqResponsible && this.$store.state.allFaqResponsible.includes($store.state.me._id)">
          <router-link :to="{ name: 'appeals' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('appeals')}">
            <i class="as__menu__link__icon">
              <DocumentationIco/>
            </i>
            <span class="as__menu__link__title">Обращения</span>
            <span class="as__menu__link__badge" v-if="$store.state.unprocessesAppeals">{{ $store.state.unprocessesAppeals }}</span>
          </router-link>
        </li>
      </mq-layout>
    </ul>
  </div>
</template>

<script>
import TaskIco from '@/components/svg/task'
import CalcIco from '@/components/svg/calc'
import DocumentsIco from '@/components/svg/DocumentsIco'
import DocumentationIco from '@/components/svg/documentation'
import CoursesIcon from '@/components/svg/CoursesIcon'
import HomeIco from '@/components/svg/home'
import DocPlus from '@/components/svg/doc_plus'
import ContactIco from '@/components/svg/contact'
// import CabinetIco from '@/components/svg/cabinet'
import ApplyIco from '@/components/svg/Apply'
import DiadocIcon from '@/components/svg/DiadocSideBarIcon'
import CarIcon from '@/components/svg/Car'
import TruckIcon from '@/components/svg/Truck'

export default {
  name: 'SidebarMenu',
  components: {
    DiadocIcon,
    DocumentsIco,
    CalcIco,
    DocPlus,
    ContactIco,
    TaskIco,
    HomeIco,
    DocumentationIco,
    CoursesIcon,
    // CabinetIco,
    ApplyIco,
    CarIcon,
    TruckIcon
  },
  props: {
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputRefs: {
        submenu_trades: this.$refs.submenu_trades,
        submenu_digest: this.$refs.submenu_digest,
        submenu_analytics: this.$refs.submenu_analytics
      }
    }
  },
  computed: {
    sideBarState () {
      return this.$store.state.sideBarState === 'expanded'
    },
    isMobile () {
      return window.innerWidth <= 1025
    }
  },
  watch: {
    sideBarState () {
      if (this.sideBarState === false) {
        if (this.$refs.submenu_trades) {
          this.$refs.submenu_trades.checked = false
        }
        if (this.$refs.submenu_digest) {
          this.$refs.submenu_digest.checked = false
        }
        if (this.$refs.submenu_analytics) {
          this.$refs.submenu_analytics.checked = false
        }
      }
    }
  },
  methods: {
    isSubRouterLinkActive (routerName) {
      if (typeof routerName === 'string') {
        return routerName === this.$route.name || routerName === this.$route.meta.parent || routerName === `${this.$route.name}${this.$route.hash}`
      } else {
        return routerName.filter(item => item === this.$route.name || item === this.$route.meta.parent).length !== 0
      }
    },

    closeAllExcept (target, open) {
      if (this.isMobile && !this.sideBarState) {
        if (this.$refs.submenu_trades) {
          this.$refs.submenu_trades.checked = false
        }
        if (this.$refs.submenu_digest) {
          this.$refs.submenu_digest.checked = false
        }
        if (this.$refs.submenu_analytics) {
          this.$refs.submenu_analytics.checked = false
        }
      } else {
        const thisRef = this.$refs[target]
        if (thisRef) {
          for (const inputKey in this.$refs) {
            if (inputKey !== target) {
              this.$refs[inputKey].checked = false
            } else this.$refs[inputKey].checked = open
          }
          const thisSubmenu = thisRef.nextElementSibling
          if (thisSubmenu) {
            const input = document.querySelector(`input#${target}`)
            thisSubmenu.style.top = input.getBoundingClientRect().top + 'px'
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.submenu-checkbox
  position absolute !important
  width 0px !important
  height 0px !important

.sidebar_bottom
  fixed left bottom
  width 100%
  background $dark
  z-index 200

  ul
    display flex
    align-items center
    justify-content space-between
    padding 5px 15px
    list-style none
    flex-direction initial

    li
      flex 1

    ul
      display none

    a
      padding 0
      height 60px
      display flex
      align-items center
      justify-content center

    .as__menu__link__title
      display none

      &.active
        svg
          path
            stroke $orange

    .as__menu__link__badge
      position absolute
      top -10px
      right -5px
</style>
